<div class="search-footer" [class.compact]="status() === 'no-results'">
  <span class="hint">
    <span class="keycap">↑</span>
    <span class="keycap">↓</span>
    navigieren
  </span>
  @if (status() !== 'no-results') {
    <span class="hint">
      <span class="keycap">↵</span>
      öffnen
    </span>
  }
  <span class="hint">
    <span class="keycap">esc</span>
    schließen
  </span>
  @if (status() === 'results') {
    <span class="result-count">{{ totalCount() }} Treffer</span>
  }
</div>
